<template>
  <Content title="账号管理">
    <template v-slot:header>
      <a-button
        type="primary"
        @click="handleClickAdd"
      >+ 新建</a-button>
      <a-button @click="handleCreateChannel">批量创建渠道账号</a-button>
    </template>
    <template v-slot:search>
      <a-form
        :form="form"
        layout="inline"
        @submit.prevent.stop="handleSearch"
      >
        <a-row :gutter="32">
          <a-col :span="8">
            <a-form-item label="账号">
              <a-input
                v-decorator="['accountName']"
                placeholder="请输入"
                autocomplete="off"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="姓名">
              <a-input
                v-decorator="['fullName']"
                placeholder="请输入"
                autocomplete="off"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="所属门店">
              <a-input
                v-decorator="['storeName']"
                placeholder="请输入"
                autocomplete="off"
                allow-clear
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="状态">
              <a-select
                v-decorator="['state']"
                placeholder="全部"
                allow-clear
              >
                <a-select-option value="ON">启用</a-select-option>
                <a-select-option value="OFF">禁用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
              >查询</a-button>
              <a-button
                html-type="reset"
                @click.prevent.stop="handleSearchReset"
              >重置</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </template>
    <template v-slot:content>
      <a-table
        :columns="columns"
        :data-source="accountPage.list"
        :row-key="record => record.id"
        :pagination="pagination"
      >
        <template #createTimeRender="value">
          <template v-if="value">{{ value | moment($consts.DATETIME_FORMAT) }}</template>
        </template>
        <template #statusRender="item, record">
          <a-badge
            color="#F7517F"
            status="error"
            text="已锁定"
            v-if="record.isLock"
          />
          <a-badge
            status="success"
            text="启用"
            v-else-if="record.state === 'ON'"
          />
          <a-badge
            color="#F7517F"
            status="error"
            text="禁用"
            v-else
          />
        </template>
        <template
          #oprRender="text, record"
          class="opr-list"
        >
          <a
            class="opr"
            @click="handleClickEdit(record)"
          >编辑</a>
          <a-popconfirm
            :title="`你确定要${record.state === 'ON' ? '禁用' : '启用'}吗`"
            @confirm="handleToggleState(record.userName, record.state)"
          >
            <a class="opr">{{ record.state === 'ON' ? '禁用' : '启用' }}</a>
          </a-popconfirm>
          <a-popconfirm
            title="你确定要删除吗"
            @confirm="handleDelete(record.userName)"
          >
            <a class="opr">删除</a>
          </a-popconfirm>
          <a-popconfirm
            v-if="record.isLock"
            title="你确定要解锁吗，解锁后账号恢复可登录"
            @confirm="handleUnLock(record.userName)"
          >
            <a class="opr">解锁</a>
          </a-popconfirm>
        </template>
      </a-table>
    </template>
    <aside>
      <EditModal
        v-if="showEditModal"
        :visible="showEditModal"
        :account="editingAccount"
        @ok="handleEdit"
        @cancel="handleEditCancel"
      />
    </aside>
    <ChannelBatchCreate :visible.sync="channelVisible"/>
  </Content>
</template>

<script>
import { mapState } from 'vuex';
import Content from '@/components/Content';
import ChannelBatchCreate from '@/pages/sub/account/ChannelBatchCreate';
import EditModal from './edit-modal';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: '租户号',
    dataIndex: 'tenantCode',
  },
  {
    title: '账号',
    dataIndex: 'userName',
  },
  {
    title: '姓名',
    dataIndex: 'fullName',
  },
  {
    title: '角色',
    dataIndex: 'roleName',
  },
  {
    title: '身份',
    dataIndex: 'accountType',
    customRender: (text) => {
      let showText = '商户';
      switch (text) {
        case 'STORE': {
          showText = '门店';
          break;
        }
        case 'CHANNEL': {
          showText = '渠道';
          break;
        }
        case 'MERCHANT': {
          showText = '商户';
          break;
        }
        default: break;
      }
      return showText;
    },
  },
  {
    title: '身份信息',
    dataIndex: 'accountTypeValueName',
    width: 400,
  },
  // {
  //   title: '企业微信企业id',
  //   dataIndex: 'corpId',
  // },
  // {
  //   title: '企业微信账号',
  //   dataIndex: 'corpUserId',
  // },
  {
    title: '状态',
    dataIndex: 'state',
    scopedSlots: { customRender: 'statusRender' },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTimeRender' },
  },
  {
    title: '操作',
    key: 'opr',
    scopedSlots: { customRender: 'oprRender' },
  },
];

export default {
  components: {
    Content,
    EditModal,
    ChannelBatchCreate,
  },
  data() {
    return {
      columns,
      currPage: 1,
      currFieldsValue: {},
      showEditModal: false,
      editingAccount: null,
      form: this.$form.createForm(this, { name: 'account_search' }),
      channelVisible: false, // 是否显示批量生成弹窗
    };
  },
  computed: {
    ...mapState('account', ['accountPage']),
    pagination() {
      return {
        current: this.currPage,
        defaultPageSize: this.$consts.PAGE_SIZE,
        total: this.accountPage.total,
        onChange: this.handlePagination,
      };
    },
  },
  methods: {
    // 点击显示批量导入弹窗
    handleCreateChannel() {
      this.channelVisible = true;
    },
    handleEdit(values) {
      const { editingAccount } = this;
      const payload = { ...values };
      let eventType;

      if (editingAccount) {
        eventType = 'account/edit';
        payload.accountName = editingAccount.userName;
      } else {
        eventType = 'account/add';
      }

      this.$store.dispatch(eventType, payload)
        .then(() => {
          this.$message.success('操作成功');
          this.showEditModal = false;
          this.loadData();
        });
    },
    handleEditCancel() {
      this.showEditModal = false;
    },
    handleToggleState(accountName, status) {
      this.$store.dispatch('account/updateStatus', {
        accountName,
        status: status === 'ON' ? 'off' : 'on',
      })
        .then(() => this.loadData());
    },
    handleDelete(accountName) {
      this.$store.dispatch('account/del', { accountName })
        .then(() => this.loadData());
    },
    handleClickAdd() {
      this.editingAccount = null;
      this.showEditModal = true;
    },
    handleClickEdit(account) {
      this.editingAccount = account;
      this.showEditModal = true;
    },
    loadData(pageNum = 1) {
      this.currPage = pageNum;
      this.$store.dispatch('account/fetchPage', {
        pageNum,
        pageSize: this.$consts.PAGE_SIZE,
        ...this.currFieldsValue,
      });
    },
    handlePagination(pageNum) {
      this.loadData(pageNum);
    },
    handleSearch() {
      this.currFieldsValue = this.form.getFieldsValue();
      this.loadData();
    },
    handleSearchReset() {
      this.form.resetFields();
      this.handleSearch();
    },
    handleUnLock(accountName) {
      // 5.锁定用户  /web-background/account/lock?accountName=test0914
      // 6.解锁用户  /web-background/account/unLock?accountName=test0914
      this.$store.dispatch('account/unLock', { accountName })
        .then(() => this.loadData());
    },
  },
  created() {
    this.loadData();
  },
};
</script>
